import i18n from "../../../../../../constants/i18n";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import { getKhattabatResultsStore } from "../../../../../../stores/khattabat-stores/results-store";
import { TKhattabatMessage } from "../../../../../../Types";
import Messages from "../../../../khattabat-clients/conversation/body/messages";

const Comments = withLiteObserverAndTheme<{
  matchComments: TKhattabatMessage[];
  matchConversationID: string;
  alkhattabaUUID: string;
  matchUUID: string;
  matchID: number;
  clientID: number;
  clientUUID: string;
  oneOOneCId: string
}>((props) => {
  const {
    matchComments,
    matchConversationID,
    alkhattabaUUID,
    matchUUID,
    matchID,
    clientUUID,
    clientID,
    oneOOneCId,
    theme
  } = props;
  const { colors } = theme;

  return (
    <ET3Div
      width={1510}
      height={510}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => { }}
    >
      <ET3Div
        width={1188}
        height={510}
        alignItems={"center"}
        fDirection={"column"}
        style={{}}
        color={""}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => { }}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={24}
          isSpan={false}
          text={i18n.get("COMMENTS")}
          style={{}}
          color={colors.all.red}
        />
        <Messages
          messages={matchComments}
          conversationID={getKhattabatResultsStore().getClientOneOOneMConversationID(
            matchConversationID
          )}
          alkhattabaUUID={alkhattabaUUID}
          userUUID={clientUUID}
          userID={clientID}
          peerID={matchID}
          peerUUID={matchUUID}
          conversationType={"101M_COMMENTS"}
          oneOTwoConversationId={""}
          oneOOneCId={oneOOneCId}
          applicationStatus={""}
        />
      </ET3Div>
      <Et3Margin top={0} bottom={0} left={100} right={100} />
    </ET3Div>
  );
});

export default Comments;
